import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { AppLaunchType } from "./app_launch_type";
import { ContactAuthorizationStatus } from "./contact_authorization_status";
export const protobufPackage = "snapchat.cdp.cof";
export interface BillboardSignals {
    emailVerified: boolean;
    phoneVerified: boolean;
    notificationPermGranted: boolean;
    contactPermGranted: boolean;
    mutualFriendsCount: number;
    groupsCount: number;
    hasNonTeamSnapchatConversations: boolean;
    emailSet: boolean;
    bitmojiSet: boolean;
    hasAddFriendsRequest: boolean;
    appLaunchFromPush: boolean;
    appLaunchType: AppLaunchType;
    campaignLocalImpressionCount: number;
    campaignLocalLastImpressionTimeSecsToNow: string;
    campaignLocalContinuousDismissCount: number;
    fstNumInAppWarnings: number;
    fstShouldChangePassword: boolean;
    audioRecordPermGranted: boolean;
    mutualFriendsWithBirthdayCount: number;
    campaignLocalDismissCount: number;
    memoriesCount: number;
    campaignLocalFirstImpressionTimeSecsToNow: string;
    campaignLocalClickCount: number;
    campaignLocalInteractionCount: number;
    campaignLocalLastInteractionTimeSecsToNow: string;
    lockScreenWidgetAppOpenFromPush: boolean;
    communityCount: number;
    campaignLocalFirstClickTimeSecsToNow: string;
    campaignLocalLastClickTimeSecsToNow: string;
    campaignLocalFirstDismissTimeSecsToNow: string;
    campaignLocalLastDismissTimeSecsToNow: string;
    campaignLocalFirstInteractionTimeSecsToNow: string;
    serverImpressionCount: number;
    serverClickCount: number;
    serverDismissCount: number;
    serverInteractionCount: number;
    serverFirstImpressionTimeSecsToNow: string;
    serverLastImpressionTimeSecsToNow: string;
    serverFirstClickTimeSecsToNow: string;
    serverLastClickTimeSecsToNow: string;
    serverFirstDismissTimeSecsToNow: string;
    serverLastDismissTimeSecsToNow: string;
    serverFirstInteractionTimeSecsToNow: string;
    serverLastInteractionTimeSecsToNow: string;
    serverContinuousDismissCount: number;
    contactPermOsGranted: boolean;
    contactPermUserGranted: boolean;
    contactPermOsAuthorizationStatus: ContactAuthorizationStatus;
}
function createBaseBillboardSignals(): BillboardSignals {
    return {
        emailVerified: false,
        phoneVerified: false,
        notificationPermGranted: false,
        contactPermGranted: false,
        mutualFriendsCount: 0,
        groupsCount: 0,
        hasNonTeamSnapchatConversations: false,
        emailSet: false,
        bitmojiSet: false,
        hasAddFriendsRequest: false,
        appLaunchFromPush: false,
        appLaunchType: 0,
        campaignLocalImpressionCount: 0,
        campaignLocalLastImpressionTimeSecsToNow: "0",
        campaignLocalContinuousDismissCount: 0,
        fstNumInAppWarnings: 0,
        fstShouldChangePassword: false,
        audioRecordPermGranted: false,
        mutualFriendsWithBirthdayCount: 0,
        campaignLocalDismissCount: 0,
        memoriesCount: 0,
        campaignLocalFirstImpressionTimeSecsToNow: "0",
        campaignLocalClickCount: 0,
        campaignLocalInteractionCount: 0,
        campaignLocalLastInteractionTimeSecsToNow: "0",
        lockScreenWidgetAppOpenFromPush: false,
        communityCount: 0,
        campaignLocalFirstClickTimeSecsToNow: "0",
        campaignLocalLastClickTimeSecsToNow: "0",
        campaignLocalFirstDismissTimeSecsToNow: "0",
        campaignLocalLastDismissTimeSecsToNow: "0",
        campaignLocalFirstInteractionTimeSecsToNow: "0",
        serverImpressionCount: 0,
        serverClickCount: 0,
        serverDismissCount: 0,
        serverInteractionCount: 0,
        serverFirstImpressionTimeSecsToNow: "0",
        serverLastImpressionTimeSecsToNow: "0",
        serverFirstClickTimeSecsToNow: "0",
        serverLastClickTimeSecsToNow: "0",
        serverFirstDismissTimeSecsToNow: "0",
        serverLastDismissTimeSecsToNow: "0",
        serverFirstInteractionTimeSecsToNow: "0",
        serverLastInteractionTimeSecsToNow: "0",
        serverContinuousDismissCount: 0,
        contactPermOsGranted: false,
        contactPermUserGranted: false,
        contactPermOsAuthorizationStatus: 0,
    };
}
export const BillboardSignals: MessageFns<BillboardSignals> = {
    encode(message: BillboardSignals, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.emailVerified !== false) {
            writer.uint32(8).bool(message.emailVerified);
        }
        if (message.phoneVerified !== false) {
            writer.uint32(16).bool(message.phoneVerified);
        }
        if (message.notificationPermGranted !== false) {
            writer.uint32(24).bool(message.notificationPermGranted);
        }
        if (message.contactPermGranted !== false) {
            writer.uint32(32).bool(message.contactPermGranted);
        }
        if (message.mutualFriendsCount !== 0) {
            writer.uint32(40).int32(message.mutualFriendsCount);
        }
        if (message.groupsCount !== 0) {
            writer.uint32(48).int32(message.groupsCount);
        }
        if (message.hasNonTeamSnapchatConversations !== false) {
            writer.uint32(56).bool(message.hasNonTeamSnapchatConversations);
        }
        if (message.emailSet !== false) {
            writer.uint32(64).bool(message.emailSet);
        }
        if (message.bitmojiSet !== false) {
            writer.uint32(72).bool(message.bitmojiSet);
        }
        if (message.hasAddFriendsRequest !== false) {
            writer.uint32(80).bool(message.hasAddFriendsRequest);
        }
        if (message.appLaunchFromPush !== false) {
            writer.uint32(88).bool(message.appLaunchFromPush);
        }
        if (message.appLaunchType !== 0) {
            writer.uint32(96).int32(message.appLaunchType);
        }
        if (message.campaignLocalImpressionCount !== 0) {
            writer.uint32(104).int32(message.campaignLocalImpressionCount);
        }
        if (message.campaignLocalLastImpressionTimeSecsToNow !== "0") {
            writer.uint32(112).int64(message.campaignLocalLastImpressionTimeSecsToNow);
        }
        if (message.campaignLocalContinuousDismissCount !== 0) {
            writer.uint32(120).int32(message.campaignLocalContinuousDismissCount);
        }
        if (message.fstNumInAppWarnings !== 0) {
            writer.uint32(128).int32(message.fstNumInAppWarnings);
        }
        if (message.fstShouldChangePassword !== false) {
            writer.uint32(136).bool(message.fstShouldChangePassword);
        }
        if (message.audioRecordPermGranted !== false) {
            writer.uint32(144).bool(message.audioRecordPermGranted);
        }
        if (message.mutualFriendsWithBirthdayCount !== 0) {
            writer.uint32(152).int32(message.mutualFriendsWithBirthdayCount);
        }
        if (message.campaignLocalDismissCount !== 0) {
            writer.uint32(160).int32(message.campaignLocalDismissCount);
        }
        if (message.memoriesCount !== 0) {
            writer.uint32(168).int32(message.memoriesCount);
        }
        if (message.campaignLocalFirstImpressionTimeSecsToNow !== "0") {
            writer.uint32(176).int64(message.campaignLocalFirstImpressionTimeSecsToNow);
        }
        if (message.campaignLocalClickCount !== 0) {
            writer.uint32(184).int32(message.campaignLocalClickCount);
        }
        if (message.campaignLocalInteractionCount !== 0) {
            writer.uint32(192).int32(message.campaignLocalInteractionCount);
        }
        if (message.campaignLocalLastInteractionTimeSecsToNow !== "0") {
            writer.uint32(200).int64(message.campaignLocalLastInteractionTimeSecsToNow);
        }
        if (message.lockScreenWidgetAppOpenFromPush !== false) {
            writer.uint32(208).bool(message.lockScreenWidgetAppOpenFromPush);
        }
        if (message.communityCount !== 0) {
            writer.uint32(216).int32(message.communityCount);
        }
        if (message.campaignLocalFirstClickTimeSecsToNow !== "0") {
            writer.uint32(224).int64(message.campaignLocalFirstClickTimeSecsToNow);
        }
        if (message.campaignLocalLastClickTimeSecsToNow !== "0") {
            writer.uint32(232).int64(message.campaignLocalLastClickTimeSecsToNow);
        }
        if (message.campaignLocalFirstDismissTimeSecsToNow !== "0") {
            writer.uint32(240).int64(message.campaignLocalFirstDismissTimeSecsToNow);
        }
        if (message.campaignLocalLastDismissTimeSecsToNow !== "0") {
            writer.uint32(248).int64(message.campaignLocalLastDismissTimeSecsToNow);
        }
        if (message.campaignLocalFirstInteractionTimeSecsToNow !== "0") {
            writer.uint32(256).int64(message.campaignLocalFirstInteractionTimeSecsToNow);
        }
        if (message.serverImpressionCount !== 0) {
            writer.uint32(264).int32(message.serverImpressionCount);
        }
        if (message.serverClickCount !== 0) {
            writer.uint32(272).int32(message.serverClickCount);
        }
        if (message.serverDismissCount !== 0) {
            writer.uint32(280).int32(message.serverDismissCount);
        }
        if (message.serverInteractionCount !== 0) {
            writer.uint32(288).int32(message.serverInteractionCount);
        }
        if (message.serverFirstImpressionTimeSecsToNow !== "0") {
            writer.uint32(296).int64(message.serverFirstImpressionTimeSecsToNow);
        }
        if (message.serverLastImpressionTimeSecsToNow !== "0") {
            writer.uint32(304).int64(message.serverLastImpressionTimeSecsToNow);
        }
        if (message.serverFirstClickTimeSecsToNow !== "0") {
            writer.uint32(312).int64(message.serverFirstClickTimeSecsToNow);
        }
        if (message.serverLastClickTimeSecsToNow !== "0") {
            writer.uint32(320).int64(message.serverLastClickTimeSecsToNow);
        }
        if (message.serverFirstDismissTimeSecsToNow !== "0") {
            writer.uint32(328).int64(message.serverFirstDismissTimeSecsToNow);
        }
        if (message.serverLastDismissTimeSecsToNow !== "0") {
            writer.uint32(336).int64(message.serverLastDismissTimeSecsToNow);
        }
        if (message.serverFirstInteractionTimeSecsToNow !== "0") {
            writer.uint32(344).int64(message.serverFirstInteractionTimeSecsToNow);
        }
        if (message.serverLastInteractionTimeSecsToNow !== "0") {
            writer.uint32(352).int64(message.serverLastInteractionTimeSecsToNow);
        }
        if (message.serverContinuousDismissCount !== 0) {
            writer.uint32(360).int32(message.serverContinuousDismissCount);
        }
        if (message.contactPermOsGranted !== false) {
            writer.uint32(368).bool(message.contactPermOsGranted);
        }
        if (message.contactPermUserGranted !== false) {
            writer.uint32(376).bool(message.contactPermUserGranted);
        }
        if (message.contactPermOsAuthorizationStatus !== 0) {
            writer.uint32(384).int32(message.contactPermOsAuthorizationStatus);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): BillboardSignals {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBillboardSignals();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.emailVerified = reader.bool();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.phoneVerified = reader.bool();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.notificationPermGranted = reader.bool();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.contactPermGranted = reader.bool();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.mutualFriendsCount = reader.int32();
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.groupsCount = reader.int32();
                    continue;
                }
                case 7: {
                    if (tag !== 56) {
                        break;
                    }
                    message.hasNonTeamSnapchatConversations = reader.bool();
                    continue;
                }
                case 8: {
                    if (tag !== 64) {
                        break;
                    }
                    message.emailSet = reader.bool();
                    continue;
                }
                case 9: {
                    if (tag !== 72) {
                        break;
                    }
                    message.bitmojiSet = reader.bool();
                    continue;
                }
                case 10: {
                    if (tag !== 80) {
                        break;
                    }
                    message.hasAddFriendsRequest = reader.bool();
                    continue;
                }
                case 11: {
                    if (tag !== 88) {
                        break;
                    }
                    message.appLaunchFromPush = reader.bool();
                    continue;
                }
                case 12: {
                    if (tag !== 96) {
                        break;
                    }
                    message.appLaunchType = reader.int32() as any;
                    continue;
                }
                case 13: {
                    if (tag !== 104) {
                        break;
                    }
                    message.campaignLocalImpressionCount = reader.int32();
                    continue;
                }
                case 14: {
                    if (tag !== 112) {
                        break;
                    }
                    message.campaignLocalLastImpressionTimeSecsToNow = reader.int64().toString();
                    continue;
                }
                case 15: {
                    if (tag !== 120) {
                        break;
                    }
                    message.campaignLocalContinuousDismissCount = reader.int32();
                    continue;
                }
                case 16: {
                    if (tag !== 128) {
                        break;
                    }
                    message.fstNumInAppWarnings = reader.int32();
                    continue;
                }
                case 17: {
                    if (tag !== 136) {
                        break;
                    }
                    message.fstShouldChangePassword = reader.bool();
                    continue;
                }
                case 18: {
                    if (tag !== 144) {
                        break;
                    }
                    message.audioRecordPermGranted = reader.bool();
                    continue;
                }
                case 19: {
                    if (tag !== 152) {
                        break;
                    }
                    message.mutualFriendsWithBirthdayCount = reader.int32();
                    continue;
                }
                case 20: {
                    if (tag !== 160) {
                        break;
                    }
                    message.campaignLocalDismissCount = reader.int32();
                    continue;
                }
                case 21: {
                    if (tag !== 168) {
                        break;
                    }
                    message.memoriesCount = reader.int32();
                    continue;
                }
                case 22: {
                    if (tag !== 176) {
                        break;
                    }
                    message.campaignLocalFirstImpressionTimeSecsToNow = reader.int64().toString();
                    continue;
                }
                case 23: {
                    if (tag !== 184) {
                        break;
                    }
                    message.campaignLocalClickCount = reader.int32();
                    continue;
                }
                case 24: {
                    if (tag !== 192) {
                        break;
                    }
                    message.campaignLocalInteractionCount = reader.int32();
                    continue;
                }
                case 25: {
                    if (tag !== 200) {
                        break;
                    }
                    message.campaignLocalLastInteractionTimeSecsToNow = reader.int64().toString();
                    continue;
                }
                case 26: {
                    if (tag !== 208) {
                        break;
                    }
                    message.lockScreenWidgetAppOpenFromPush = reader.bool();
                    continue;
                }
                case 27: {
                    if (tag !== 216) {
                        break;
                    }
                    message.communityCount = reader.int32();
                    continue;
                }
                case 28: {
                    if (tag !== 224) {
                        break;
                    }
                    message.campaignLocalFirstClickTimeSecsToNow = reader.int64().toString();
                    continue;
                }
                case 29: {
                    if (tag !== 232) {
                        break;
                    }
                    message.campaignLocalLastClickTimeSecsToNow = reader.int64().toString();
                    continue;
                }
                case 30: {
                    if (tag !== 240) {
                        break;
                    }
                    message.campaignLocalFirstDismissTimeSecsToNow = reader.int64().toString();
                    continue;
                }
                case 31: {
                    if (tag !== 248) {
                        break;
                    }
                    message.campaignLocalLastDismissTimeSecsToNow = reader.int64().toString();
                    continue;
                }
                case 32: {
                    if (tag !== 256) {
                        break;
                    }
                    message.campaignLocalFirstInteractionTimeSecsToNow = reader.int64().toString();
                    continue;
                }
                case 33: {
                    if (tag !== 264) {
                        break;
                    }
                    message.serverImpressionCount = reader.int32();
                    continue;
                }
                case 34: {
                    if (tag !== 272) {
                        break;
                    }
                    message.serverClickCount = reader.int32();
                    continue;
                }
                case 35: {
                    if (tag !== 280) {
                        break;
                    }
                    message.serverDismissCount = reader.int32();
                    continue;
                }
                case 36: {
                    if (tag !== 288) {
                        break;
                    }
                    message.serverInteractionCount = reader.int32();
                    continue;
                }
                case 37: {
                    if (tag !== 296) {
                        break;
                    }
                    message.serverFirstImpressionTimeSecsToNow = reader.int64().toString();
                    continue;
                }
                case 38: {
                    if (tag !== 304) {
                        break;
                    }
                    message.serverLastImpressionTimeSecsToNow = reader.int64().toString();
                    continue;
                }
                case 39: {
                    if (tag !== 312) {
                        break;
                    }
                    message.serverFirstClickTimeSecsToNow = reader.int64().toString();
                    continue;
                }
                case 40: {
                    if (tag !== 320) {
                        break;
                    }
                    message.serverLastClickTimeSecsToNow = reader.int64().toString();
                    continue;
                }
                case 41: {
                    if (tag !== 328) {
                        break;
                    }
                    message.serverFirstDismissTimeSecsToNow = reader.int64().toString();
                    continue;
                }
                case 42: {
                    if (tag !== 336) {
                        break;
                    }
                    message.serverLastDismissTimeSecsToNow = reader.int64().toString();
                    continue;
                }
                case 43: {
                    if (tag !== 344) {
                        break;
                    }
                    message.serverFirstInteractionTimeSecsToNow = reader.int64().toString();
                    continue;
                }
                case 44: {
                    if (tag !== 352) {
                        break;
                    }
                    message.serverLastInteractionTimeSecsToNow = reader.int64().toString();
                    continue;
                }
                case 45: {
                    if (tag !== 360) {
                        break;
                    }
                    message.serverContinuousDismissCount = reader.int32();
                    continue;
                }
                case 46: {
                    if (tag !== 368) {
                        break;
                    }
                    message.contactPermOsGranted = reader.bool();
                    continue;
                }
                case 47: {
                    if (tag !== 376) {
                        break;
                    }
                    message.contactPermUserGranted = reader.bool();
                    continue;
                }
                case 48: {
                    if (tag !== 384) {
                        break;
                    }
                    message.contactPermOsAuthorizationStatus = reader.int32() as any;
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<BillboardSignals>, I>>(base?: I): BillboardSignals {
        return BillboardSignals.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<BillboardSignals>, I>>(object: I): BillboardSignals {
        const message = createBaseBillboardSignals();
        message.emailVerified = object.emailVerified ?? false;
        message.phoneVerified = object.phoneVerified ?? false;
        message.notificationPermGranted = object.notificationPermGranted ?? false;
        message.contactPermGranted = object.contactPermGranted ?? false;
        message.mutualFriendsCount = object.mutualFriendsCount ?? 0;
        message.groupsCount = object.groupsCount ?? 0;
        message.hasNonTeamSnapchatConversations = object.hasNonTeamSnapchatConversations ?? false;
        message.emailSet = object.emailSet ?? false;
        message.bitmojiSet = object.bitmojiSet ?? false;
        message.hasAddFriendsRequest = object.hasAddFriendsRequest ?? false;
        message.appLaunchFromPush = object.appLaunchFromPush ?? false;
        message.appLaunchType = object.appLaunchType ?? 0;
        message.campaignLocalImpressionCount = object.campaignLocalImpressionCount ?? 0;
        message.campaignLocalLastImpressionTimeSecsToNow = object.campaignLocalLastImpressionTimeSecsToNow ?? "0";
        message.campaignLocalContinuousDismissCount = object.campaignLocalContinuousDismissCount ?? 0;
        message.fstNumInAppWarnings = object.fstNumInAppWarnings ?? 0;
        message.fstShouldChangePassword = object.fstShouldChangePassword ?? false;
        message.audioRecordPermGranted = object.audioRecordPermGranted ?? false;
        message.mutualFriendsWithBirthdayCount = object.mutualFriendsWithBirthdayCount ?? 0;
        message.campaignLocalDismissCount = object.campaignLocalDismissCount ?? 0;
        message.memoriesCount = object.memoriesCount ?? 0;
        message.campaignLocalFirstImpressionTimeSecsToNow = object.campaignLocalFirstImpressionTimeSecsToNow ?? "0";
        message.campaignLocalClickCount = object.campaignLocalClickCount ?? 0;
        message.campaignLocalInteractionCount = object.campaignLocalInteractionCount ?? 0;
        message.campaignLocalLastInteractionTimeSecsToNow = object.campaignLocalLastInteractionTimeSecsToNow ?? "0";
        message.lockScreenWidgetAppOpenFromPush = object.lockScreenWidgetAppOpenFromPush ?? false;
        message.communityCount = object.communityCount ?? 0;
        message.campaignLocalFirstClickTimeSecsToNow = object.campaignLocalFirstClickTimeSecsToNow ?? "0";
        message.campaignLocalLastClickTimeSecsToNow = object.campaignLocalLastClickTimeSecsToNow ?? "0";
        message.campaignLocalFirstDismissTimeSecsToNow = object.campaignLocalFirstDismissTimeSecsToNow ?? "0";
        message.campaignLocalLastDismissTimeSecsToNow = object.campaignLocalLastDismissTimeSecsToNow ?? "0";
        message.campaignLocalFirstInteractionTimeSecsToNow = object.campaignLocalFirstInteractionTimeSecsToNow ?? "0";
        message.serverImpressionCount = object.serverImpressionCount ?? 0;
        message.serverClickCount = object.serverClickCount ?? 0;
        message.serverDismissCount = object.serverDismissCount ?? 0;
        message.serverInteractionCount = object.serverInteractionCount ?? 0;
        message.serverFirstImpressionTimeSecsToNow = object.serverFirstImpressionTimeSecsToNow ?? "0";
        message.serverLastImpressionTimeSecsToNow = object.serverLastImpressionTimeSecsToNow ?? "0";
        message.serverFirstClickTimeSecsToNow = object.serverFirstClickTimeSecsToNow ?? "0";
        message.serverLastClickTimeSecsToNow = object.serverLastClickTimeSecsToNow ?? "0";
        message.serverFirstDismissTimeSecsToNow = object.serverFirstDismissTimeSecsToNow ?? "0";
        message.serverLastDismissTimeSecsToNow = object.serverLastDismissTimeSecsToNow ?? "0";
        message.serverFirstInteractionTimeSecsToNow = object.serverFirstInteractionTimeSecsToNow ?? "0";
        message.serverLastInteractionTimeSecsToNow = object.serverLastInteractionTimeSecsToNow ?? "0";
        message.serverContinuousDismissCount = object.serverContinuousDismissCount ?? 0;
        message.contactPermOsGranted = object.contactPermOsGranted ?? false;
        message.contactPermUserGranted = object.contactPermUserGranted ?? false;
        message.contactPermOsAuthorizationStatus = object.contactPermOsAuthorizationStatus ?? 0;
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
